import VenuePageNav, { VenuePageNavProps } from "./VenuePageNav";

import { useVenuePageTheme } from "@punchup/venues";
import { withOpacity } from "@punchup/utils/colors";

interface VenuePageNavThemedProps extends VenuePageNavProps {}

export default function VenuePageNavThemed(props: VenuePageNavThemedProps) {
  const { navTextColor, accentColor } = useVenuePageTheme(props.venueSlug);
  return (
    <VenuePageNav
      {...props}
      className="md:mx-10"
      theme={{
        textColor: withOpacity(navTextColor, 0.75),
        borderColor: withOpacity(navTextColor, 0.75),
        activeTextColor: navTextColor,
        activeBorderColor: navTextColor,
        accentColor,
      }}
    />
  );
}
